import { useState } from "react";
import { useCopyToClipboard } from "react-use";
import { Check, Copy } from "lucide-react";
import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { Input } from "~/components/ui/input";

interface ShareConversationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  conversationId: string;
}

export function ShareConversationModal({
  open,
  onOpenChange,
  conversationId,
}: ShareConversationModalProps) {
  const [, copy] = useCopyToClipboard();
  const [copied, setCopied] = useState(false);

  const shareUrl = new URL(
    `/shared/conversations/${conversationId}`,
    window.location.origin
  ).toString();

  const handleCopyLink = () => {
    copy(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Share Analysis</DialogTitle>
          <DialogDescription className="text-gray-800">
            Anyone with this link can view this analysis, as long as they have access to the
            dataset. Deleting the analysis will revoke access for all viewers.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-2">
          <Input value={shareUrl} readOnly className="flex-1 text-sm text-muted-foreground" />
          <Button onClick={handleCopyLink} className="shrink-0">
            {copied ? (
              <>
                <Check className="size-4" />
                Copied
              </>
            ) : (
              <>
                <Copy className="size-4" />
                Copy Link
              </>
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
